import type { EntityValidationRules } from "services/validationService";
import TransferType from "../transferType";
import { observable } from "mobx";

export default class BankExportFilters {
  @observable exportName?: string;
  @observable refundType?: TransferType;

  @observable createdDate?: Date;
}

export const BankExportFilterValidationRules: EntityValidationRules<BankExportFilters> = {
  exportName: {
    isLength: {
      min: 3,
      customMessage: "min3Characters",
    },
  },
};
